import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'

const state = {
  Parent: {},
  GallerieAlbums: [],
  EditingImageGallerieAlbumId: 0,
  BackupImageGalleryAlbum: null,
  NewImageGallerieAlbum: null,
  UI: {
    activeCategoryTab: '',
    activeMainTab: 'image'
  },
  FirstTimeOpen: false
}

const getters = {
  Parent: state => state.Parent,
  GallerieAlbums: state => state.GallerieAlbums,
  IsEditing: state => state.EditingImageGallerieAlbumId !== 0,
  EditingImageGallerieAlbum: state => {
    if (state.EditingImageGallerieAlbumId === 0) {
      return {}
    }
    return state.GallerieAlbums.find(album => album.Id === state.EditingImageGallerieAlbumId)
  },
  NewImageGallerieAlbum: state => state.NewImageGallerieAlbum,
  IsAddingNewImageGallerieAlbum: state => state.NewImageGallerieAlbum !== null,
  UI: state => state.UI,
  FirstTimeOpen: state => state.FirstTimeOpen
}

const mutations = {
  RESET_MODULE_DATA (state) {
    state.Parent = {}
    state.GallerieAlbums = []
    state.EditingImageGallerieAlbumId = 0
    state.BackupImageGalleryAlbum = null
    state.NewImageGallerieAlbum = null
    state.FirstTimeOpen = false
    state.UI = {
      activeCategoryTab: '',
      activeMainTab: 'image'
    }
  },
  [mutationNames.SET_IMAGE_GALLERIE_PARENT] (state, parent) {
    state.Parent = parent
  },
  [mutationNames.UPDATE_IMAGE_GALLERIE_PARENT] (state, payload) {
    Object.assign(state.Parent, payload)
  },
  [mutationNames.SET_IMAGE_GALLERIE_ALBUMS] (state, GallerieAlbums) {
    state.GallerieAlbums = GallerieAlbums
  },
  [mutationNames.UPDATE_IMAGE_GALLERIE_ALBUM] (state, { Id, payload }) {
    let gallerieAlbums = state.GallerieAlbums.find(album => album.Id === Id)
    if (gallerieAlbums) {
      Object.assign(gallerieAlbums, payload)
    }
  },
  // [mutationNames.UPDATE_ALBUM_IMAGE_IMAGE] (state, { Id, payload }) {
  //   const ImageGallery = state.GallerieAlbums.find(page => page.Id === Id)
  //   if (ImageGallery) {
  //     ImageGallery.PostImage = payload.PostImage
  //   }
  // },
  [mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM] (state, payload) {
    state.NewImageGallerieAlbum = payload
  },
  [mutationNames.UPDATE_NEW_IMAGE_GALLERIE_ALBUM] (state, payload) {
    state.NewImageGallerieAlbum = Object.assign({}, state.NewImageGallerieAlbum, payload)
  },
  [mutationNames.SET_IMAGE_GALLERIE_EDITING_ALBUM] (state, AlbumId) {
    state.EditingImageGallerieAlbumId = AlbumId
    state.BackupImageGalleryAlbum = Object.assign({}, state.GallerieAlbums.find(album => album.Id === AlbumId))
  },
  [mutationNames.CANCEL_IMAGE_GALLERIE_ALBUM_EDITING] (state, BackupImageGalleryAlbum) {
    const index = state.GallerieAlbums.findIndex(album => album.Id === state.EditingImageGallerieAlbumId)
    state.GallerieAlbums.splice(index, 1, BackupImageGalleryAlbum)
  },
  [mutationNames.CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA] (state) {
    state.EditingImageGallerieAlbumId = 0
    state.BackupImageGalleryAlbum = null
    state.NewImageGallerieAlbum = null
  },
  UPDATE_UI (state, payload) {
    Object.assign(state.UI, payload)
  },
  setFirstTimeOpenValue (state, payload) {
    state.FirstTimeOpen = payload
  }
}

const actions = {
  async initModule ({ getters, commit, dispatch }, subscriptionModuleId) {
    dispatch('resetModuleData')
    const response = await dispatch('populateImageGallery', subscriptionModuleId)
    await dispatch('populateImageGalleriesAlbums', response.Id)
  },
  updateUI ({ commit }, payload) {
    commit('UPDATE_UI', payload)
  },
  resetModuleData ({ commit }) {
    commit('RESET_MODULE_DATA')
  },
  async populateImageGallery ({ commit }, subscriptionModuleId) {
    let response = await api.AppModules.getImageGallery(subscriptionModuleId)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    commit(mutationNames.SET_IMAGE_GALLERIE_PARENT, response)
    return response
  },
  async populateImageGalleriesAlbums ({ commit }, modulesImageGalleriesId) {
    let response = await api.AppModules.getImageGalleriesAlbums(modulesImageGalleriesId)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    commit(mutationNames.SET_IMAGE_GALLERIE_ALBUMS, response)
    return response
  },
  editImageGalleryAlbum ({ commit }, AlbumId) {
    commit(mutationNames.SET_IMAGE_GALLERIE_EDITING_ALBUM, AlbumId)
  },
  closeImageGalleryAlbumEditingPage ({ commit }) {
    commit(mutationNames.CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA)
  },
  async cancelImageGalleryAlbumEditing ({ state, commit }) {
    await commit(mutationNames.CANCEL_IMAGE_GALLERIE_ALBUM_EDITING, Object.assign({}, state.BackupImageGalleryAlbum))
    await commit(mutationNames.CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA)
  },
  updateEditingImageGalleryAlbum ({ commit, state }, payload) {
    commit(mutationNames.UPDATE_IMAGE_GALLERIE_ALBUM, { Id: state.EditingImageGallerieAlbumId, payload })
  },
  createNewImageGalleryAlbum ({ commit }, payload) {
    commit(mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM, payload)
  },
  updateNewImageGalleryAlbum ({ commit }, payload) {
    commit(mutationNames.UPDATE_NEW_IMAGE_GALLERIE_ALBUM, payload)
  },
  // async populateTextModule ({ dispatch, commit }, subscriptionModuleId) {
  //   const response = await api.AppModules.getTextModule(subscriptionModuleId)
  //   commit(mutationNames.SET_ALBUM_IMAGE_PARENT, response || {})
  //   if (response) {
  //     dispatch('populateImageGalleries', response.Id)
  //   } else {
  //     commit(mutationNames.SET_ALBUM_IMAGES, [])
  //   }
  // },
  updateParent ({ commit }, payload) {
    commit(mutationNames.UPDATE_IMAGE_GALLERIE_PARENT, payload)
  },
  saveImageGalleryModule ({ getters }) {
    return api.AppModules.saveImageGalleryModule(getters.Parent)
  },
  patchImageGallery ({ getters }, payload) {
    return api.AppModules.patchImageGallery(getters.Parent.Id, payload)
  },
  async addImageGallerieAlbum ({ commit, dispatch }, payload) {
    // return api.AppModules.saveImageGallerieAlbum(payload)
    const response = await dispatch('saveImageGallerieAlbum', payload)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    if (payload.Images.length > 0) {
      payload.Images.map((image) => {
        image.ModulesImageGalleriesAlbums_Id = response
        return image
      })
      const responseImages = await dispatch('saveImageGallerieAlbumImages', payload)
      if (!responseImages) {
        throw new Error('No data from API. ;(')
      }
      return responseImages
    }
  },
  copyImageGallerieAlbum ({ commit }, payload) {
    return api.AppModules.copyImageGallerieAlbum(payload)
  },
  async saveImageGallerieAlbumAndImages ({ commit, dispatch }, payload) {
    const response = await dispatch('saveImageGallerieAlbum', payload)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    const responseImages = await dispatch('saveImageGallerieAlbumImages', payload)
    if (!responseImages) {
      throw new Error('No data from API. ;(')
    }
    return responseImages
  },
  saveImageGallerieAlbum ({ commit }, payload) {
    return api.AppModules.saveImageGallerieAlbum(payload)
  },
  saveImageGallerieAlbumImages ({ commit }, payload) {
    return api.AppModules.saveImageGallerieAlbumImages(payload.Images)
  },
  saveImageGallerieAlbums ({ commit }, payload) {
    return api.AppModules.saveImageGallerieAlbums(payload)
  },
  deleteImageGalleryAlbum ({ commit }, modulesImageGalleryAlbumId) {
    return api.AppModules.deleteImageGalleryAlbum(modulesImageGalleryAlbumId)
  },
  async updateImageGalleryImage ({ getters, commit }, { Id, payload }) {
    const ImageGallery = getters.ImageGalleries.find(page => page.Id === Id)
    if (ImageGallery) {
      await api.AppModules.patchImageGallery(ImageGallery.Id, {
        PostImage: payload.PostImage
      })
    }
    commit(mutationNames.UPDATE_ALBUM_IMAGE_IMAGE, { Id, payload })
  },
  setFirstTimeOpenValue ({ commit }, payload) {
    commit('setFirstTimeOpenValue', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/imageGalleryModule.js